import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'tasks';

const LIST_COMMENTS = 'comments';
const CREATE_COMMENT = 'comments';
const SNOOZE = 'snooze';
const UNSNOOZE = 'unsnooze';
const CLOSE = 'close';
const START = 'start';
const SKIP = 'skip';
const ACCESS = 'access';
const GAMEPLAN = 'complexity-pricing-agreement';
const SINGLE_CHOICE_OPTIONS = 'single-choice-options';

const PREVIEW_URL = 'preview-url';
const SHARE = 'share';

export const TASKS_ENDPOINTS = {
  acceptComplexityPricing: (id: string) => formatEndpoint(`${id}/${GAMEPLAN}/accept`, namespace),
  accessTask: (id: string, clientId: string) => formatEndpoint(`${id}/${ACCESS}/${clientId}`, namespace),
  closeTask: (id: string) => formatEndpoint(`${id}/${CLOSE}`, namespace),
  confirmDone: (id: string) => formatEndpoint(`${id}/confirm_done`, namespace),
  createComment: (id: string) => formatEndpoint(`${id}/${CREATE_COMMENT}`, namespace),
  createTask: () => formatEndpoint('', namespace),
  getShareUrl: (taskId: string) => formatEndpoint(`${taskId}/${PREVIEW_URL}`, namespace),
  giftTask: () => formatEndpoint('gift', namespace),
  listComments: (id: string) => formatEndpoint(`${id}/${LIST_COMMENTS}`, namespace),
  listTasks: () => formatEndpoint('', namespace),
  previewTask: (encodedId: string) => formatEndpoint(`${SHARE}/${encodedId}`, namespace),
  retrieveTask: (id: string) => formatEndpoint(`${id}`, namespace),
  skipTask: (id: string) => formatEndpoint(`${id}/${SKIP}`, namespace),
  snoozeTask: (id: string) => formatEndpoint(`${id}/${SNOOZE}`, namespace),
  startTask: (id: string) => formatEndpoint(`${id}/${START}`, namespace),
  triggerSingleChoiceOption: (id: string) => formatEndpoint(`${id}/${SINGLE_CHOICE_OPTIONS}`, namespace),
  unsnoozeTask: (id: string) => formatEndpoint(`${id}/${UNSNOOZE}`, namespace),
  updateTask: (id: string) => formatEndpoint(`${id}`, namespace),
};
